<template>
    <sa-page-layout :btnNewVisible="true" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <data-analysis-dashboard-list-component ref="DataAnalysisDashboardListComponent" @afterLoadData="onAfterLoadData"></data-analysis-dashboard-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalysisDashboardListComponent from "../components/DataAnalysisDashboardListComponent.vue";
export default {
    components: { SaPageLayout, DataAnalysisDashboardListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/dataanalysisdashboard",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.DataAnalysisDashboardListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
